import actions from 'actions/operators'
import operatorGroupActions from 'actions/operatorGroups'
import userActions from 'actions/users'
import operatorScheduleExceptionActions from 'actions/operators/scheduleExceptions'
import operatorIssueLimitListActions from 'actions/operatorIssueLimitLists'
import { createFormViewContainer } from 'factories/FormView'
import { createChildItemsDispatchToProps } from 'helpers/formViews'
import Component from 'components/Operators/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getOperatorGroups: (params) => dispatch(operatorGroupActions.getOptions(params)),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    ...createChildItemsDispatchToProps(
      dispatch,
      'OperatorScheduleExceptions',
      operatorScheduleExceptionActions
    ),
    getOperatorIssueLimitLists: (params, options) =>
      dispatch(operatorIssueLimitListActions.getItems({ ...params, pageIndex: 0 }, options)),
    createOperatorIssueLimitLists: (params, options) =>
      dispatch(operatorIssueLimitListActions.createItem(params, options)),
    deleteOperatorIssueLimitLists: (params, options) =>
      dispatch(operatorIssueLimitListActions.deleteItems(params, options)),
  }),
})(Component)
